module.exports = __webpack_public_path__ + "img/ad4.6af97f61.jpg";